import React, { useState } from "react";
import { Image, Modal, Button } from "react-bootstrap";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

const Filter = (props) => {
  const [state, setState] = useState({
    open: false,
  });
  /**************** Status ****************/
  const [status, setStatus] = useState(false);
  const [statusText, setStatusText] = useState("All");
  /**************** Availablity ****************/
  const [activeAvailablity, setActiveAvaiblity] = useState("");
  /**************** Item Tags ****************/
  const [availability, setAvailabilty] = useState(false);
  const [itemTags, setItemTags] = useState("");

  const [active, setActive] = useState(false);

  const [item, setItem] = useState(false);
  const [cuisine, setCuisine] = useState(false);

  /**************** Applicable Services ****************/
  const [applicableServices, setApplicableServices] = useState("");

  const onOpenModal = () => {
    setState({ open: true });
  };
  const handleCloseModal = () => {
    setState({ open: false });
  };
  const availabilityStatus = [
    { name: "Available", id: "AVAILABLE", color: "green" },
    { name: "SoldOut", id: "SOLDOUT", color: "red" },
    { name: "Not Available", id: "NOTAVAILABLE", color: "black" },
  ];

  const classes = useStyles();
  const [age, setAge] = React.useState("");

  const handleChange = (event) => {
    setAge(event.target.value);
  };

  const onClickSetAvailablity = (id) => {
    setActiveAvaiblity(id);
  };
  const onClickSetStatus = (data) => {
    setStatusText(data);
  };
  const onClickItemTags = (data) => {
    setItemTags(data);
  };
  const onClickAplicableServices = (data) => {
    setApplicableServices(data);
  };

  const onClickResetFilter = () => {
    setActiveAvaiblity("");
    setStatusText("All");
    setAge("");
    setItemTags("");
    setApplicableServices("");
    setAvailabilty(false);
    setStatus(false);
    setItem(false);
    setActive(false);
    setCuisine(false);
    props.availabilityData("");
    props.statusData("");
    props.itemTagsData("");
    props.cuisineTypeData("");
    props.activeServiceData("");
    handleCloseModal();
  };
  const onClickApplyFilter = () => {
    props.availabilityData(activeAvailablity);
    props.statusData(statusText);
    props.itemTagsData(itemTags);
    props.cuisineTypeData(age);
    props.activeServiceData(applicableServices);
    setAvailabilty(false);
    setStatus(false);
    setItem(false);
    setActive(false);
    setCuisine(false);
    handleCloseModal();
  };

  return (
    <React.Fragment>
      <div
        onClick={onOpenModal}
        className="d-flex align-items-center justify-content-between cursor"
      >
        <Image
          alt="filter"
          title="filter"
          width="20px"
          src={require("../../../assets/images/ActionImages/image/filter.svg")}
        />
        <div className="f12-500 text-blue mx-2">Filter</div>
        <i className="fa fa-angle-down text-blue" aria-hidden="true"></i>
      </div>
      <Modal show={state.open} onHide={handleCloseModal} centered>
        <Modal.Header className="py-0 pt-2 border-0" closeButton>
          <Modal.Title className="f24_700_HelveticaNeue">Filter</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="f16-500 pb-4">
            Select one relevant option from below
          </div>
          <div className="row">
            <div className="col-4">
              <label className="enRadioWithText f12-500">
                Availability
                <input
                  type="radio"
                  name="CouponDiscountType"
                  // checked={props.ratingChecked}
                  onChange={() => {
                    setAvailabilty(true);
                    setStatus(false);
                    setItem(false);
                    setActive(false);
                    setCuisine(false);
                  }}
                />
                <span className="checkmark"></span>
              </label>
            </div>
            <div className="col-4">
              <label className="enRadioWithText f12-500">
                Status
                <input
                  type="radio"
                  name="CouponDiscountType"
                  // checked={props.serviceChecked}
                  onChange={() => {
                    setAvailabilty(false);
                    setStatus(true);
                    setItem(false);
                    setActive(false);
                    setCuisine(false);
                  }}
                />
                <span className="checkmark"></span>
              </label>
            </div>
            <div className="col-4">
              <label className="enRadioWithText f12-500">
                Item Tags
                <input
                  type="radio"
                  name="CouponDiscountType"
                  // checked={props.serviceChecked}
                  // onChange={props.ratingCheckedClick}
                  onChange={() => {
                    setAvailabilty(false);
                    setStatus(false);
                    setItem(true);
                    setActive(false);
                    setCuisine(false);
                  }}
                />
                <span className="checkmark"></span>
              </label>
            </div>
            <div className="col-4">
              <label className="enRadioWithText f12-500">
                Active Services
                <input
                  type="radio"
                  name="CouponDiscountType"
                  // checked={props.serviceChecked}
                  // onChange={props.ratingCheckedClick}
                  onChange={() => {
                    setAvailabilty(false);
                    setStatus(false);
                    setItem(false);
                    setActive(true);
                    setCuisine(false);
                  }}
                />
                <span className="checkmark"></span>
              </label>
            </div>
            <div className="col-4">
              <label className="enRadioWithText f12-500">
                Cuisine Type
                <input
                  type="radio"
                  name="CouponDiscountType"
                  // checked={props.serviceChecked}
                  // onChange={props.ratingCheckedClick}
                  onChange={() => {
                    setAvailabilty(false);
                    setStatus(false);
                    setItem(false);
                    setActive(false);
                    setCuisine(true);
                  }}
                />
                <span className="checkmark"></span>
              </label>
            </div>
            <div className="col-4"></div>
          </div>
          {/* <div className="d-flex align-items-center justify-content-between pb-3"></div>
          <div className="d-flex align-items-center pb-3"></div> */}

          <div className="container">
            <>
              {availability ? (
                <div className="row ">
                  {availabilityStatus.map((availablity, index) => (
                    <div className="col-4 p-2" key={index}>
                      <div
                        className={` p-2 ${
                          availablity.id === activeAvailablity &&
                          `sts_sld_btn_box_a`
                        }`}
                        onClick={() => onClickSetAvailablity(availablity.id)}
                        style={{
                          backgroundColor: `${availablity.color}`,
                          borderRadius: "5px",
                          color: "white",
                        }}
                        align="center"
                        type="button"
                      >
                        {availablity.name}
                      </div>
                    </div>
                  ))}
                </div>
              ) : null}
            </>
            <>
              {status ? (
                <div className="row ">
                  <div className="d-flex flex-wrap align-items-center">
                    <div
                      className="enCheckWithText mr-3"
                      style={{
                        border: statusText === "All" ? "2px solid #EE3A23" : "",
                        borderRadius: statusText === "All" ? "5px" : "",
                      }}
                      onClick={() => onClickSetStatus("All")}
                    >
                      <input type="radio" name="Status" />
                      <label>All</label>
                    </div>
                    <div
                      className="enCheckWithText mr-3"
                      style={{
                        border:
                          statusText === "Active" ? "2px solid #EE3A23" : "",
                        borderRadius: statusText === "Active" ? "5px" : "",
                      }}
                      onClick={() => onClickSetStatus("Active")}
                    >
                      <input type="radio" name="Status" />
                      <label>Active</label>
                    </div>
                    <div
                      className="enCheckWithText mr-3"
                      style={{
                        border:
                          statusText === "Inactive" ? "2px solid #EE3A23" : "",
                        borderRadius: statusText === "Inactive" ? "5px" : "",
                      }}
                      onClick={() => onClickSetStatus("Inactive")}
                    >
                      <input type="radio" name="Status" />
                      <label>Inactive</label>
                    </div>
                  </div>
                </div>
              ) : null}
            </>
            <>
              {item ? (
                <div className="row ">
                  <div className="d-flex flex-wrap align-items-center">
                    {props.tags_info.map((data, index) => (
                      <div className="col-4 p-2" key={index}>
                        <div
                          className="enCheckWithText mr-3"
                          style={{
                            border:
                              itemTags === data.title
                                ? "2px solid #EE3A23"
                                : "",
                            borderRadius: itemTags === data.title ? "5px" : "",
                          }}
                          onClick={() => onClickItemTags(data.title)}
                        >
                          <input type="radio" name={data.title} />
                          <label>{data.title}</label>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ) : null}
            </>
            <>
              {active ? (
                <div className="row ">
                  <div className="d-flex flex-wrap align-items-center">
                    <div
                      className="enCheckWithText mr-3"
                      onClick={() => onClickAplicableServices("takeaway")}
                    >
                      <input type="radio" name="Status" />
                      <label>Take Away</label>
                    </div>
                    <div
                      className="enCheckWithText mr-3"
                      onClick={() => onClickAplicableServices("curbside")}
                    >
                      <input type="radio" name="Status" />
                      <label>CurbSide</label>
                    </div>
                    <div
                      className="enCheckWithText mr-3"
                      onClick={() => onClickAplicableServices("dinein")}
                    >
                      <input type="radio" name="Status" />
                      <label>Dine-In</label>
                    </div>
                    <div
                      className="enCheckWithText mr-3"
                      onClick={() => onClickAplicableServices("skiptheline")}
                    >
                      <input type="radio" name="Status" />
                      <label>Skip The Line</label>
                    </div>
                  </div>
                </div>
              ) : null}
            </>
            <>
              {cuisine && cuisine ? (
                <div className="row">
                  <div className="col-5 pl-0 d-flex flex-wrap align-items-center">
                    <FormControl
                      variant="outlined"
                      className={`${classes.formControl} w-100`}
                    >
                      <InputLabel id="demo-simple-select-outlined-label">
                        Cusine Type
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-outlined-label"
                        id="demo-simple-select-outlined"
                        value={age}
                        onChange={handleChange}
                        label="Cuisine Type"
                      >
                        {props.cuisine_type.map((data, index) => (
                          <MenuItem value={data.title} key={index}>
                            <em>{data.title}</em>
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                </div>
              ) : null}
            </>
          </div>
        </Modal.Body>
        <Modal.Footer className="justify-content-start border-0">
          <Button
            variant="outline-secondary"
            className="btn-lg mr-4 px-5"
            onClick={onClickResetFilter}
          >
            Reset Filter
          </Button>
          <Button
            variant="danger"
            className="btn-lg px-5"
            onClick={onClickApplyFilter}
          >
            Apply Filter
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

Filter.propTypes = {
  auth: PropTypes.object.isRequired,
  update_item_menu_setup: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  tags_info: state.category && state.category.tags_info,
  cuisine_type: state.onboarding?.restaurantDetails?.selected_cusine,
  //  && state.category.cusine,
});

export default connect(mapStateToProps, null)(Filter);
// export default Filter;
